module.exports = __webpack_public_path__ + "media/images/common/ico_01-b258c0e7da7395e6f05c87416968a423.png";